import React, { useEffect, useMemo, useState } from "react";
import Modal from "react-bootstrap/Modal";
import Button from "react-bootstrap/Button";
import Form from "react-bootstrap/Form";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import { useForm } from "react-hook-form";
import "./EditModal.css";
import { postData, putData } from "../../../../Services/Api";
import { ColorRing } from "react-loader-spinner";
import { GetUserDetails } from "../../../../Helpers/Utility";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faMinus, faPlus } from "@fortawesome/free-solid-svg-icons";
// import { toast } from "react-toastify";

export default function AddModal({ show, onClose, token, updateUser }) {
  const [error, setError] = useState("");
  const [isLoading, setIsLoading] = useState(true);
  const [subscriptionPlans, setSubscriptionPlans] = useState([]);
  const [data, setData] = useState(0);

  const getSubscriptionPlans = async (token, page, search) => {
    if (!token) return;
    const headers = {
      Authorization: `Bearer ${token}`,
    };

    const data = {
      search_text: "",
      page_number: 1,
      limit: 1000,
      sortBy: "created_at",
      sortAscDesc: "desc",
    };

    setIsLoading(true);
    const getDataResponse = await postData("pricing-plan-list", data, headers);
    setIsLoading(false);
    const { plans, currentPage, recordCount, totalPageCount } =
      getDataResponse?.data?.data || {};
    // console.log(getDataResponse, "res");

    setSubscriptionPlans(plans || []);
  };

  useEffect(() => {
    if (show) {
      setIsLoading(true);
      const userDetails = GetUserDetails();
      if (userDetails?.token) {
        getSubscriptionPlans(userDetails.token, 1, "");
      }
    }
  }, [show]);

  const {
    register,
    handleSubmit,
    watch,
    setValue,
    formState: { errors },
  } = useForm({
    defaultValues: {
      name: "",
      dob: "",
      email: "",
      subscription: "",
      suspended: "",
      password: "",
      confirmPassword: "",
      dataSubscribed: 0,
      amount: 0,
      currency: "USD",
    },
  });

  const selectedPlan = useMemo(() => {
    return subscriptionPlans.find((ele) => ele.id == watch("subscription"));
  }, [watch("subscription"), subscriptionPlans]);

  useEffect(() => {
    if (selectedPlan?.data_min_gb) setData(selectedPlan?.data_min_gb);
    else setData(0);
  }, [selectedPlan]);

  const incData = () => {
    if (data >= selectedPlan?.data_max_gb && selectedPlan?.data_max_gb > 0)
      return;
    setData((dt) => dt + selectedPlan?.data_step_gb);
  };

  const decData = () => {
    if (data <= selectedPlan?.data_min_gb) return;
    setData((dt) => dt - selectedPlan?.data_step_gb);
  };

  // const calculateFinalAmountPackage = (
  //   amount,
  //   increaseAmount,
  //   discountPercentage
  // ) => {
  //   let discountAmount = (increaseAmount * discountPercentage) / 100;
  //   discountAmount = parseFloat(discountAmount.toFixed(2));
  //   let finalAmount = increaseAmount - discountAmount;
  //   return parseFloat(amount) + finalAmount;
  // };

  // useEffect(() => {
  //   if (selectedPlan) {
  //     if (data == selectedPlan.data_min_gb) {
  //       setValue("amount", selectedPlan.price_initial);
  //       return;
  //     }
  //     const newAmount = calculateFinalAmountPackage(
  //       watch("amount"),
  //       selectedPlan.price_per_data,
  //       selectedPlan.price_percentage_off
  //     );
  //     setValue(
  //       "amount",
  //       newAmount?.toFixed ? newAmount?.toFixed(2) : newAmount
  //     );
  //   }
  // }, [data]);

  const [showPasswordFields, setShowPasswordFields] = useState(true);

  const headers = {
    Authorization: `Bearer ${token}`,
  };

  function convertDateFormat(dateString) {
    // Check if the input is in the correct format
    const regex = /^\d{4}-\d{2}-\d{2}$/;
    if (!regex.test(dateString)) {
      throw new Error("Input must be in the format yyyy-mm-dd");
    }

    // Split the input date string
    const [year, month, day] = dateString.split("-");

    // Rearrange the components to dd-mm-yyyy format
    return `${day}-${month}-${year}`;
  }

  // Function to handle edit action
  const onSubmit = async (formData) => {
    const sendData = {
      name: formData?.name || "",
      email: formData?.email || "",
      dob: formData.dob? convertDateFormat(formData.dob): "",
      password: formData?.newPassword || "",
      confirm_password: formData?.newPassword || "",
      data_subscribed: data,
      amount2: "",
      currency2: "",
      amount1: 0,
      currency1: "USD",
      plan_pricing_id: formData?.subscription,
    };
    const getDataResponse = await postData(
      "add-subscriber-details",
      sendData,
      headers
    );
    if (getDataResponse.success) {
      if (getDataResponse?.data?.code === 401) {
        setError(getDataResponse?.data?.message);
      } else {
        // toast.success(getDataResponse.data.message)
        updateUser();
        onClose();
      }
    } else {
      setError(getDataResponse?.message);
    }
  };

  // Function to handle password change checkbox toggle
  const handlePasswordChangeToggle = () => {
    setShowPasswordFields(!showPasswordFields);
  };

  const password = watch("password");

  useEffect(() => {
    if (password) {
      setError("");
    }
  }, [password]);

  return (
    <Modal show={show} centered size="lg" onHide={onClose}>
      <Modal.Header className="px-4" closeButton>
        <Modal.Title>Add User</Modal.Title>
      </Modal.Header>
      <Modal.Body className="px-4">
        {isLoading ? (
          <div className="d-flex justify-content-center">
            <ColorRing
              type="ThreeDots"
              color="#00BFFF"
              height={80}
              width={80}
            />
          </div>
        ) : (
          <Form onSubmit={handleSubmit(onSubmit)}>
            <Row>
              <Col md={6}>
                <Form.Group className="mb-3" controlId="formName">
                  <Form.Label className="fw-medium">
                    Name
                    <span className="text-danger">*</span>
                  </Form.Label>
                  <Form.Control
                    type="text"
                    className="customFormTextAdmin rounded-5"
                    placeholder="Enter name"
                    {...register("name", { required: "Name is required" })}
                  />
                  {errors.name && (
                    <span className="text-danger">{errors.name.message}</span>
                  )}
                </Form.Group>
              </Col>
              <Col md={6}>
                <Form.Group className="mb-3" controlId="formEmail">
                  <Form.Label className="fw-medium">
                    Email
                    <span className="text-danger">*</span>
                  </Form.Label>
                  <Form.Control
                    type="email"
                    className="customFormTextAdmin rounded-5"
                    placeholder="Enter email"
                    {...register("email", {
                      required: "Email is required",
                      pattern: {
                        value:
                          /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4}$/,
                        message: "Invalid email address",
                      },
                    })}
                  />
                  {errors.email && (
                    <span className="text-danger">{errors.email.message}</span>
                  )}
                </Form.Group>
              </Col>
            </Row>
            <Row className="align-items-center">
              <Col md={6}>
                <Form.Group className="mb-3" controlId="formSubscription">
                  <Form.Label className="fw-medium">
                    Subscription Plan
                    <span className="text-danger">*</span>
                  </Form.Label>
                  <Form.Select
                    className="customFormTextAdmin rounded-5"
                    {...register("subscription", {
                      required: "Subscritption is required",
                    })}
                  >
                    <option value="">N/A</option>
                    {subscriptionPlans.map((ele) => (
                      <option key={ele.id} value={ele?.id}>
                        {ele?.title}
                      </option>
                    ))}
                  </Form.Select>
                  {errors.subscription && (
                    <span className="text-danger">
                      {errors.subscription.message}
                    </span>
                  )}
                </Form.Group>
              </Col>
              <Col md={6}>
                <Form.Group className="mb-3" controlId="dob">
                  <Form.Label className="fw-medium">Date of birth</Form.Label>
                  <Form.Control
                    type="date"
                    className="customFormTextAdmin rounded-5"
                    {...register("dob")}
                  ></Form.Control>
                  {errors.dob && (
                    <span className="text-danger">{errors.dob.message}</span>
                  )}
                </Form.Group>
              </Col>
            </Row>
            {watch("subscription") && (
              <>
                {/* <Row>
                  <Col md={6}>
                    <Form.Group className="mb-3" controlId="formName">
                      <Form.Label className="fw-medium">Currency</Form.Label>
                      <Form.Control
                        readOnly
                        type="text"
                        className="customFormTextAdmin rounded-5"
                        placeholder="Enter currency"
                        {...register("currency", {
                          required: "Currency is required",
                        })}
                      />
                      {errors.currency && (
                        <span className="text-danger">
                          {errors.currency.message}
                        </span>
                      )}
                    </Form.Group>
                  </Col>
                  <Col md={6}>
                    <Form.Group className="mb-3" controlId="formName">
                      <Form.Label className="fw-medium">Amount</Form.Label>
                      <Form.Control
                        readOnly
                        type="number"
                        className="customFormTextAdmin rounded-5"
                        placeholder="Enter amount"
                        {...register("amount", {
                          required: "Amount is required",
                        })}
                      />
                      {errors.amount && (
                        <span className="text-danger">
                          {errors.amount.message}
                        </span>
                      )}
                    </Form.Group>
                  </Col>
                </Row> */}

                <Row className="align-items-center">
                  <Col
                    md={12}
                    className="d-flex align-items-center justify-content-center flex-column"
                  >
                    <div className="fw-medium">
                      Subscribed Data<span className="text-danger">*</span>
                    </div>
                    <div
                      className="d-flex justify-content-start align-items-center mb-3"
                      style={{ gap: "20px" }}
                    >
                      <FontAwesomeIcon
                        onClick={decData}
                        title="Add"
                        icon={faMinus}
                        style={{
                          width: "25px",
                          height: "25px",
                          marginLeft: "10px",
                          cursor: "pointer",
                          color: "green",
                        }}
                      />
                      <span
                        className="customFormTextAdmin rounded-5"
                        style={{ fontSize: "25px" }}
                      >
                        {data}
                      </span>
                      <FontAwesomeIcon
                        onClick={incData}
                        title="Add"
                        icon={faPlus}
                        style={{
                          width: "25px",
                          height: "25px",
                          marginLeft: "10px",
                          cursor: "pointer",
                          color: "green",
                        }}
                      />
                    </div>
                  </Col>
                </Row>
              </>
            )}
            {showPasswordFields && (
              <Row>
                <Col md={6}>
                  <Form.Group className="mb-3" controlId="formNewPassword">
                    <Form.Label className="fw-medium">
                      New Password <span className="text-danger">*</span>
                    </Form.Label>
                    <Form.Control
                      type="password"
                      className="customFormTextAdmin rounded-5"
                      placeholder="Enter New Password"
                      {...register("newPassword", {
                        required: "New Password is required",
                      })}
                    />
                    {errors?.newPassword && (
                      <span className="text-danger">
                        {errors?.newPassword?.message}
                      </span>
                    )}
                  </Form.Group>
                </Col>
                <Col md={6}>
                  <Form.Group className="mb-3" controlId="formConfirmPassword">
                    <Form.Label className="fw-medium">
                      Confirm Password <span className="text-danger">*</span>
                    </Form.Label>
                    <Form.Control
                      type="password"
                      className="customFormTextAdmin rounded-5"
                      placeholder="Enter Confirm Password"
                      {...register("confirmPassword", {
                        required: "Confirm Password is required",
                        validate: (value) =>
                          value === watch("newPassword") ||
                          "Your confirm password does not match with new password",
                      })}
                    />
                    {errors.confirmPassword && (
                      <span className="text-danger">
                        {errors.confirmPassword.message}
                      </span>
                    )}
                  </Form.Group>
                </Col>
                {error && <div className="alert alert-danger">{error}</div>}
              </Row>
            )}
            <Modal.Footer className="d-flex justify-content-between">
              <Button
                onClick={onClose}
                className="respoNavBtn btn btn-default bg-transparent border-1 border-black text-black rounded-5 pt-2 pb-2 px-4"
              >
                Cancel
              </Button>
              <Button
                type="submit"
                className="respoNavBtn btn btn-default startedBtn border-1 border-success rounded-5 pt-2 pb-2 px-4"
              >
                Save
              </Button>
            </Modal.Footer>
          </Form>
        )}
      </Modal.Body>
    </Modal>
  );
}
